export type AppLanguage = 'en' | 'si' | 'ta';

export const LANGUAGE_STORAGE_KEY = 'agd.language';

export const LANGUAGE_OPTIONS: { code: AppLanguage; labelKey: string }[] = [
  { code: 'en', labelKey: 'languages.english' },
  { code: 'si', labelKey: 'languages.sinhala' },
  { code: 'ta', labelKey: 'languages.tamil' },
];

export function normalizeAppLanguage(value: string | undefined | null): AppLanguage {
  if (value === 'si' || value === 'ta' || value === 'en') return value;
  return 'en';
}

/** Endonym labels — each language name in its own script (matches j-net header dropdown). */
export function getLanguageEndonym(code: AppLanguage): string {
  if (code === 'en') return 'English';
  if (code === 'si') return 'සිංහල';
  if (code === 'ta') return 'தமிழ்';
  return code;
}
